<template >
    <div>
        <careers-detail-inner :key="remounterKey" ></careers-detail-inner>
    </div>
</template>

<script>
    import CareersDetailInner from '@/components/CareersDetailInner'
    export default {
        name: 'careers-jobs-detail',
        components: {
            'careers-detail-inner': CareersDetailInner
        },
        data() {
            return {

            }
        },
        computed: {
            remounterKey: {
                get: function () {
                    return this.$store.state.remounterKey;
                },
                set: function (value) {

                }
            }
        },

    }

</script>
